var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgPaymentCard16 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m5.107503,11.107503l0,-2l2,0l0,2l-2,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m8.107503,9.107503l0,2l2,0l0,-2l-2,0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m0.982503,15.232503l0,-10l0,-4l10,0c2.2091,0 4,1.79086 4,4l0,6c0,2.2091 -1.7909,4 -4,4l-10,0zm2,-2l8,0c1.1046,0 2,-0.8954 2,-2l0,-6c0,-1.10457 -0.8954,-2 -2,-2l-8,0l0,2l10,0l0,2l-10,0l0,6z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPaymentCard16);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;